import { render, staticRenderFns } from "./user-training.vue?vue&type=template&id=8dfd6992"
import script from "./user-training.vue?vue&type=script&lang=js"
export * from "./user-training.vue?vue&type=script&lang=js"
import style0 from "./user-training.vue?vue&type=style&index=0&id=8dfd6992&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports